"use strict";

/**
 * Global entrypoint for the stats collection.
 * 
 * Usage:
 * 
 * 1) Add you data directly
 * ```js
 * _stats_collector.add('some_key', data);
 * ```
 * 
 * 2) Or list on event "_stats_collector.send" and add data right before page closes
 * ```js
 * document.addEventListener('_stats_collector.send', () => _stats_collector.add('some_key', data));
 * ```
 * @method _stats_collector.add
 */
var _stats_collector = function () {
  var collection = {};

  /**
   * @returns {string}
   */
  function getEndpoint() {
    return FlixUtils.isLocalEnv() ? '/_tzt.php' : 'https://ac2.tnaflix.com/collector.php';
  }

  /**
   * 
   * @param {string} key module name (e.g. "web_monitoring" or "js_errors")
   * @param {mixed} data any data collected by module
   */
  function add(key, data) {
    if (!collection.hasOwnProperty(key)) {
      collection[key] = [];
    }
    collection[key].push(data);
  }

  /**
   * Send data on closing tab
   */
  function send() {
    if (Object.keys(collection).length === 0) {
      return; // do nothing if there is no data
    }

    // Allow modules to call `_stats_collector.add()` right before sending data
    document.dispatchEvent(new Event('_stats_collector.send'));
    var fd = new FormData();
    fd.append('data', JSON.stringify(collection));
    if (typeof navigator.sendBeacon !== 'function' || !navigator.sendBeacon(getEndpoint(), fd)) {
      // Fallback if beacon is not supported
      var xhr = new XMLHttpRequest();
      xhr.open("POST", getEndpoint(), false);
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.send(JSON.stringify(collection));
    }
    collection = {};
  }

  // Send collection to the endpoint on page/tab close
  window.addEventListener('pagehide', send);
  return {
    add: add
  };
}();